
import { DescontoOrcamento } from "app/types/Desconto";
import { FormikErrors, useFormik } from "formik";
import globalMU from "globalMU";
import * as R from 'ramda';
import React, { useEffect } from "react";
import { InputNumerico } from "../inputs/InputNumerico";

const estiloDescontos = require("./descontos.module.scss").default;

export type DescontosProps = {
  dadosDeDesconto: DescontoOrcamento;
  descontosOriginais: () => void;
  onAplicar: (dadosDeDesconto: DescontoOrcamento) => void;
  onErrorValidacao: (erroDescontoOrcamento: FormikErrors<DescontoOrcamento>) => void;
  onAtualizarDadosDesconto: (dados: DescontoOrcamento) => void;
  somenteLeitura: boolean
};

export const Descontos = (props: DescontosProps) => {

  const formik = useFormik({
    initialValues: { ...props.dadosDeDesconto },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
    validate: (values) => onValidarDadosFormulario(values)
  });

  const onValidarDadosFormulario = async (desconto: DescontoOrcamento) => {
    const mensagemDescontoSuperiorOriginal = (campo: string) => `Desconto da "${campo}" superior ao valor original.`
    const mensagemDescontoSuperiorValorMaximo = (campo: string) => `Desconto da "${campo}" superior ao valor máximo permitido.`
    const mensagemDescontoMenorQueZero = (campo: string) => `Desconto do "${campo}" não pode ser menor que 0.`

    return R.pickBy(value => globalMU.isNotNullOrEmpty(value), {
      DescontoAdicionalProdutoComOferta: desconto.DescontoAdicionalProdutoComOferta > 100 ? mensagemDescontoSuperiorValorMaximo("Produtos em Oferta") :
      desconto.DescontoAdicionalProdutoComOferta < 0 ? mensagemDescontoMenorQueZero("Produtos em Oferta") : undefined,

    DescontoAdicionalProdutoSemOferta: desconto.DescontoAdicionalProdutoSemOferta > 100 ? mensagemDescontoSuperiorValorMaximo("Produtos sem Oferta") :
      desconto.DescontoAdicionalProdutoSemOferta < 0 ? mensagemDescontoMenorQueZero("Produtos sem Oferta") : undefined,

    DescontoFretePorContaDestinatario: desconto.DescontoFretePorContaDestinatario > desconto?.DescontoFretePorContaDestinatarioOriginal ? mensagemDescontoSuperiorOriginal("Tipo de Frete (FOB)") :
      desconto.DescontoFretePorContaDestinatario < 0 ? mensagemDescontoMenorQueZero("Tipo de Frete (FOB)") : undefined,

    DescontoMaximoFormaPagamento: desconto.DescontoMaximoFormaPagamento > desconto?.DescontoMaximoFormaPagamentoOriginal ? mensagemDescontoSuperiorOriginal("Forma de Pagamento") :
      desconto.DescontoMaximoFormaPagamento < 0 ? mensagemDescontoMenorQueZero("Forma de Pagamento") : undefined,

    DescontoPorFaixaValorVenda: desconto.DescontoPorFaixaValorVenda > desconto?.DescontoPorFaixaValorVendaOriginal ? mensagemDescontoSuperiorOriginal("Valor Total da Mercadoria") :
      desconto.DescontoPorFaixaValorVenda < 0 ? mensagemDescontoMenorQueZero("Valor Total da Mercadoria") : undefined,
  } as FormikErrors<DescontoOrcamento>)
  }

  const onValidarDadosDescontos = async () => {
    await formik.validateForm(formik.values)
  }

  const descontoOriginais = () => {
    const formaPagamento = <div>
      <label>Forma de Pagamento</label>
      <InputNumerico 
        disabled 
        id="DescontosAdicionais_InputFormaPagamento"
        numeroCasasDecimais={2} 
        valor={formik.values?.DescontoMaximoFormaPagamentoOriginal ?? 0} />
      <label>%</label>
    </div>

    const tipoFreteFOB = <div>
      <label>Tipo de Frete (FOB)</label>
      <InputNumerico disabled 
        id="DescontosAdicionais_InputTipoFreteFOB"
        numeroCasasDecimais={2} valor={formik.values?.DescontoFretePorContaDestinatarioOriginal ?? 0} />
      <label>%</label>
    </div>

    const valorTotalMercadoria = <div>
      <label>Valor Total da Mercadoria</label>
      <InputNumerico disabled 
        id="DescontosAdicionais_InputValorTotalMercadoria"
        numeroCasasDecimais={2} valor={formik.values?.DescontoPorFaixaValorVendaOriginal ?? 0} />
      <label>%</label>
    </div>

    const produtosEmOferta = <div>
      <label>Produtos em Oferta</label>
      <InputNumerico 
        id="DescontosAdicionais_InputProdutosEmOferta"
        disabled numeroCasasDecimais={2} valor={formik.values?.DescontoAdicionalProdutoComOfertaOriginal ?? 0} />
      <label>%</label>
    </div>

    const produtosSemOferta = <div>
      <label>Produtos sem Oferta</label>
      <InputNumerico disabled numeroCasasDecimais={2} valor={formik.values?.DescontoAdicionalProdutoSemOfertaOriginal ?? 0} />
      <label>%</label>
    </div>

    return <div className={estiloDescontos.form}>
      <label className={estiloDescontos.titulo}>Originais</label>
      <div className={estiloDescontos.itensAEsquerda}>
        <div className={estiloDescontos.descontos}>
          {formaPagamento}
          {tipoFreteFOB}
          {valorTotalMercadoria}
          {produtosEmOferta}
          {produtosSemOferta}
        </div>
      </div>
    </div>
  }

  const descontosInformados = () => {
    const formaPagamento = <div>
      <label>Forma de Pagamento</label>
      <InputNumerico
        disabled={props.somenteLeitura}
        style={formik.errors. DescontoMaximoFormaPagamento != undefined ? { borderColor: "#f25713", color: "#f25713" } : {}}
        numeroCasasDecimais={2}
        selecionaValorOnFocus={true}
        valor={formik.values?.DescontoMaximoFormaPagamento ?? 0}
        onValorModificado={(valorModificado) => formik.setFieldValue("DescontoMaximoFormaPagamento", valorModificado)} />
      <label>%</label>
    </div>

    const tipoFreteFOB = <div>
      <label>Tipo de Frete (FOB)</label>
      <InputNumerico
        disabled={props.somenteLeitura}
        style={formik.errors.DescontoFretePorContaDestinatario != undefined ? { borderColor: "#f25713", color: "#f25713" } : {}}
        numeroCasasDecimais={2}
        selecionaValorOnFocus={true}
        valor={formik.values?.DescontoFretePorContaDestinatario ?? 0}
        onValorModificado={(valorModificado) => formik.setFieldValue("DescontoFretePorContaDestinatario", valorModificado)} />
      <label>%</label>
    </div>

    const valorTotalMercadoria = <div>
      <label>Valor Total da Mercadoria</label>
      <InputNumerico
        style={formik.errors.DescontoPorFaixaValorVenda != undefined ? { borderColor: "#f25713", color: "#f25713" } : {}}
        disabled={props.somenteLeitura}
        numeroCasasDecimais={2}
        selecionaValorOnFocus={true}
        valor={formik.values?.DescontoPorFaixaValorVenda ?? 0}
        onValorModificado={(valorModificado) => formik.setFieldValue("DescontoPorFaixaValorVenda", valorModificado)} />
      <label>%</label>
    </div>

    const produtosEmOferta = <div>
      <label>Produtos em Oferta</label>
      <InputNumerico
        disabled={props.somenteLeitura}
        style={formik.errors.DescontoAdicionalProdutoComOferta != undefined ? { borderColor: "#f25713", color: "#f25713" } : {}}
        numeroCasasDecimais={2}
        valor={formik.values?.DescontoAdicionalProdutoComOferta ?? 0}
        selecionaValorOnFocus={true}
        onValorModificado={(valorModificado) =>
          formik.setFieldValue("DescontoAdicionalProdutoComOferta", valorModificado)
        } />
      <label>%</label>
    </div>

    const produtosSemOferta = <div>
      <label>Produtos sem Oferta</label>
      <InputNumerico
        disabled={props.somenteLeitura}
        style={formik.errors.DescontoAdicionalProdutoSemOferta != undefined ? { borderColor: "#f25713", color: "#f25713" } : {}}
        numeroCasasDecimais={2}
        valor={formik.values?.DescontoAdicionalProdutoSemOferta ?? 0}
        selecionaValorOnFocus={true}
        onValorModificado={(valorModificado) => formik.setFieldValue("DescontoAdicionalProdutoSemOferta", valorModificado)} />
      <label>%</label>
    </div>

    return <div className={estiloDescontos.form}>
      <label className={estiloDescontos.titulo}>Informados</label>
      <div className={estiloDescontos.itensAEsquerda}>
        <div className={estiloDescontos.descontos}>
          {formaPagamento}
          {tipoFreteFOB}
          {valorTotalMercadoria}
          {produtosEmOferta}
          {produtosSemOferta}
        </div>
      </div>
    </div>
  }

  const buttonAplicaDesconto = <div>
    <button className={estiloDescontos.botao}
      onClick={async () => {
        const erros = await formik.validateForm(formik.values)
        if (Object.keys(erros).length == 0) {
          props.onAplicar(formik.values)
        } else {
          props.onErrorValidacao(erros)
        }
      }}
      id="DescontosAdicionais_buttonAplicaDesconto">
      Aplicar Descontos
    </button>
  </div>

  const buttonDescontosOriginais = <div>
    <button className={estiloDescontos.botao} onClick={() => props.descontosOriginais()}
      id="DescontosAdicionais_buttonDescontosOriginais">
      Descontos Originais
    </button>
  </div>

  useEffect(() => {
    props.onAtualizarDadosDesconto(formik.values);
    onValidarDadosDescontos();
  }, [formik.values])

  return (
    <>
      <div className={`_mt-4 _grid _grid-cols-1 min-[992px]:_grid-cols-2`}>
        {descontoOriginais()}
        {descontosInformados()}
      </div>
      <>{!props.somenteLeitura && 
        <div className={estiloDescontos.botoes}>
          {buttonDescontosOriginais}
          {buttonAplicaDesconto}
        </div>
    }</>
    {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};
